import { ReactNode } from 'react'
import { Box, Divider, Typography } from '@mui/material'

interface Props {
  title: string
  rightSide?: ReactNode
  collapsible?: boolean
}

export function TenderSection({ title, rightSide, collapsible = false }: Props) {
  return (
    <Box mt={collapsible ? 0 : 4} width="100%">
      <Box
        width="100%"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          fontSize={16}
          textTransform="uppercase"
        >
          {title}
        </Typography>
        {rightSide}
      </Box>
      {!collapsible && <Divider sx={{ mt: 1.5, mb: 2.5 }} />}
    </Box>
  )
}
